import * as R from 'ramda'

export const hasClass = (el, className) => {
  const classNames = el.className.split(' ')

  return Boolean(R.find(R.equals(className), classNames)
  )
}

export const addClass = (el, className) => {
  if (!hasClass(el, className)) {
    const classString = el.className
    el.className = `${classString} ${className}`
  }
}

export const removeClass = (el, className) => {
  if (hasClass(el, className)) {
    const classNames = el.className.split(' ')
    const newClassNames = R.filter((cl) => cl !== className, classNames)
    el.className = newClassNames.join(' ')
  }
}

export const indexMap = R.addIndex(R.map)



// WEBPACK FOOTER //
// ./src/helpers/index.js